// export const API_URL = "http://localhost:3000"
export const API_URL = "https://kinglomo.20420501.xyz"



// WEBPACK FOOTER //
// ./src/constant.js